// Composable para obtener iniciales de un nombre (máximo dos letras, una por palabra)
export function useInitials() {
  const getInitials = (name, separator = ' ') => {
    if (!name) return ''
    const names = name.trim().split(separator).filter(Boolean)
    const firstLetter = names[0]?.charAt(0).toUpperCase() || ''
    const secondLetter = names[1]?.charAt(0).toUpperCase() || ''
    return firstLetter + secondLetter
  }
  return { getInitials }
}
